<template>

	<!--Basic-box Outer-->
	<div class="basic-box__outer">
		<div class="basic-box__title text_center">График работы</div>

		<!--Basic-box Inner-->
		<div class="basic-box__inner">

			<!--Widget-->
			<div class="widget profile-clinic__widget flex" v-for="(day, indexOfDay) in 7">

				<!--Day-->
				<div class="widget__inner widget__inner_day">
					<div class="widget__day">
						{{minWords[indexOfDay]}}
					</div>
				</div>

				<!--Time-->
				<div class="widget__inner widget__inner_time-table flex" v-if="schedule && schedule.length">

					<!--Time Item-->
					<div class="widget__time_item flex" v-if="!schedule[toNDays[indexOfDay]].period.length">
						<div class="widget__time">Выходной</div>
					</div>
					<!--Time Item End-->

					<!--Time Item-->
					<div class="widget__time_item flex" v-for="(record, indexOfRecord) in schedule[toNDays[indexOfDay]].period">
						<div class="widget__time" @click="editTime(toNDays[indexOfDay], indexOfRecord)">
							{{record.begin | local}} - {{record.end | local}}
						</div>

						<i class="widget__icon widget__icon_close icon ion-android-close"
							 @click="removeTime(toNDays[indexOfDay], indexOfRecord)"></i>
					</div>
					<!--Time Item End-->

				</div>

				<!--Пустое расписание-->
				<div class="widget__inner widget__inner_time-table flex" v-else>
					<div class="widget__time_item flex">
						<div class="widget__time">Не работает</div>
					</div>
				</div>

				<!--Add Btn-->
				<div class="widget__inner widget__inner_add" @click="addTime(toNDays[indexOfDay])">
					<i class="widget__day-btn icon ion-plus-round"></i>
				</div>

			</div>
			<!--Widget End-->

		</div>
		<!--Basic-box Inner End-->

	</div>
	<!--Basic-box Outer-->

</template>

<script>
	import Role from '@/common/Role'
	import moment from 'moment'
	import UTC from '@/common/UTC'

	export default {
		name: "ScheduleEditor",
		props: ['schedule'],
		filters: {
			local(value) {
				return UTC.toLocal(value)
			}
		},
		computed: {
			workerId() {
				return this.$route.params.profile
			},
			Role() {
				return new Role(this.$store.state.auth.user, this.$store.state.auth.worker, this.$store.state.auth.clinic)
			}
		},
		mounted() {
			this.$event.connect('scheduleEditorRecord', record => {
				this.saveTime(record)
			})
		},
		beforeDestroy() {
			this.$event.disconnect('scheduleEditorRecord')
		},
		data() {
			return {
				current: {},
				toNDays: {"0": "1", "1": "2", "2": "3", "3": "4", "4": "5", "5": "6", "6": "0"},
				minWords: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"]
			}
		},
		methods: {
			addTime (day) {
				if (!this.Role.isAdmin) {
					return false
				}

				this.current = {day: day}
				this.openModal({})
			},
			editTime (day, record) {
				if (!this.Role.isAdmin) {
					return false
				}

				this.current = {day: day, record: record}

				this.openModal({
					begin: this.schedule[day].period[record].begin,
					end: this.schedule[day].period[record].end
				})
			},
			saveTime (record) {
				if (this.current.record !== undefined) {
					if (record.isWork) {
						this.schedule[this.current.day].period[this.current.record] = {
							begin: record.begin,
							end: record.end
						}
					} else {
						this.schedule[this.current.day].period = []
					}

				} else if (this.current.day !== undefined) {

					if (!this.schedule[this.current.day]) {
						this.schedule[this.current.day] = {
							day: this.current.day,
							period: []
						}
					}

					this.schedule[this.current.day].period.push({
						begin: record.begin,
						end: record.end
					})
				}

				for (let i = 0; i <= 6; i++) {
					if (!this.schedule[i]) {
						this.schedule[i] = {
							day: i,
							period: []
						}
					}
				}

				this.$store.dispatch('worker/updateSchedule', {
					_id: this.workerId,
					schedule: this.schedule
				}).then(() => {
					this.closeModal()
					this.$event.send('updateSchedule')
				})
			},
			removeTime(dayIndex, recordIndex) {
				if (!this.Role.isAdmin) {
					this.$event.toast('i', 'У Вас недостаточно прав для редактирования')
					return false
				}

				this.schedule[dayIndex].period.splice(recordIndex, 1)

				this.$store.dispatch('worker/updateSchedule', {
					_id: this.workerId,
					schedule: this.schedule
				}).then(() => {
					this.closeModal()
				})
			},
			isNotEmpty(obj) {
				if (obj === undefined) {
					return false
				}

				return !!Object.keys(obj).length
			},
			openModal(record) {
				if (!this.Role.isAdmin) {
					this.$event.toast('i', 'У Вас недостаточно прав для редактирования')
					return false
				}

				this.$event.send('openTimeModal', record)
			},
			closeModal() {
				this.$event.send('closeTimeModal', {})
				this.current = {}
			}
		}
	}
</script>

<style>
	.widget__inner_day, .widget__inner_add {
		width: 30px !important;
	}
</style>



// WEBPACK FOOTER //
// ScheduleEditor.vue?3143a0cd